import * as React from "react"
import { formatDate, formatPercentage } from "@ui-seeker/utils/"

import { NotAllowedBlock } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function lastReviewDateColumn() {
	return {
		name: "lastReviewDate",
		label: `Last Review Date (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageLastReviewDate"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: value => value ? formatDate(value, { isString: true, receivedFormat: "yyyyMMdd" }) : <NotAllowedBlock />
		}
	}
}